import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { TranslationKeys } from '@nimbus-library/features/localization/models/enums/translation-keys.enum';
import { IChatForm } from '@nimbus-global/features/chat/models/chat-form.model';
import { CompanionReferenceType } from '@nimbus-library/features/companion-chat/models/companion-conversation.model';
import { IChatFormEntityHandler } from '@nimbus-library/features/companion-chat/services/form-entity-handlers/i-chat-form-entity-handler';
import { IOptionItem } from '@nimbus-library/features/shared/models/interfaces/i-option-item';
import { OperationsServicesLookupService } from './operations-services-lookup.service';

@Injectable({ providedIn: 'root' })
export class TeamChatFormEntityHandler implements IChatFormEntityHandler {
  public readonly entity = CompanionReferenceType.Team;

  public constructor(private readonly lookupService: OperationsServicesLookupService) {}

  public resolveReferenceOptions(
    referenceType: string,
    _form: IChatForm,
    currentValues?: Record<string, unknown>,
  ): Observable<IOptionItem[]> {
    switch (referenceType) {
      case CompanionReferenceType.Tenant:
        return this.lookupService.fetchTenants();
      case CompanionReferenceType.Team: {
        const tenantId = currentValues?.tenantId as string | undefined;
        return tenantId ? this.lookupService.fetchServices(tenantId) : of([]);
      }
      default:
        return of([]);
    }
  }

  public resolveFieldTitle(field: string): TranslationKeys {
    switch (field) {
      case 'teamId':
        return TranslationKeys.GeneralService;
      case 'tenantId':
        return TranslationKeys.AdminCommonTenant;
      case 'fromUtc':
        return TranslationKeys.GeneralFrom;
      case 'toUtc':
        return TranslationKeys.GeneralTo;
      default:
        return TranslationKeys.GeneralName;
    }
  }
}
